<template>
  <div class="main tabs_main" style="height:89%">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">物品名称：</span>
        <el-input v-model="search.assistName" :size="size" clearable placeholder="请输入物品名称"></el-input>
      </div>
      <!-- <div class="header_item">
        <span class="header_label">规格型号：</span>
        <el-select v-model="search.steelModel" placeholder="请选择规格型号">
            <el-option
            v-for="item in optionsModels"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId">
            </el-option>
        </el-select>
      </div> -->
      <!-- <div class="header_item">
        <span class="header_label">校正时间：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div> -->
      <div class="header_item">
        <el-button  :size="size" icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="校正时间" align="center" width="180"></el-table-column>
        <el-table-column prop="realName" label="校正人" align="center" ></el-table-column>
        <el-table-column prop="assistName" label="物品名称" align="center" ></el-table-column>
        <el-table-column prop="assistModel" label="规格型号" align="center"></el-table-column>
        <el-table-column prop="unit" label="计量单位" align="center" ></el-table-column>
        <el-table-column prop="correctionNum" label="校正数量" align="center" ></el-table-column>
        <el-table-column prop="correctionBefore" label="校正前库存" align="center" ></el-table-column>
        <el-table-column prop="correctionAfter" label="校正后库存" align="center" ></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { changeSize } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //校正记录管理信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
        }, // 按钮表单
        rules: {
          supplierNo: [{
            required: true,
            message: '请输入供应商编号',
            trigger: 'blur'
          }],
          optionsType: [{
            required: true,
            message: '请选择供应商类型',
            trigger: 'change'
          }],
          supplierName: [{
            required: true,
            message: '请输入供应商企业名称',
            trigger: 'blur'
          }],
          legalPerson: [{
            required: true,
            message: '请输入法定代表人',
            trigger: 'blur'
          }],
          succ: [{
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur'
          },{
            validator: (rule, value, callback) => {
                const reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确格式'))
                }
            },
            trigger: 'blur'
          }],
          contact: [{
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }],
          email: [{
            required: false,
            message: '请输入邮箱',
            trigger: 'blur'
          },{
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur'
          }],
          contactPhone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },{
            validator: (rule, value, callback) => {
                const reg = /^1[3456789]\d{9}$/
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确格式'))
                }
            },
            trigger: 'blur'
          }],
          address: [{
            required: true,
            message: '请输入公司地址',
            trigger: 'blur'
          }],
        },
        optionsRebar:[],//钢筋名称
        optionsModels:[],//规格型号
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
    //   that.getNameList()
    },
    methods: {
      //获取所有钢筋名称
      getNameList(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Rebar.searchType(params).then(res=>{
            if(res.statusMsg ==='ok'){
                this.optionsRebar = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        params.strTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Auxiliary.searchAuxiliaryCheck(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import'@/style/layout-main.scss';
</style>